<div class="blackout-date-dropdown" [attr.data-testid]="testIdPrefix">
  <div class="blackout-dropdown-selects">
    <div class="select is-small">
      <select
        [disabled]="disabled"
        [(ngModel)]="selectedMonth"
        (ngModelChange)="onPartChange()"
        [attr.data-testid]="testIdPrefix + '-month'"
        [attr.aria-label]="(ariaLabel ? ariaLabel + ' ' : '') + 'month'"
       data-ui-name="Selected month" data-ui-component="blackout-date-dropdown">
        <option *ngIf="allowEmpty" [ngValue]="''" data-ui-name="Month — selected Month" data-ui-component="blackout-date-dropdown" data-testid="blackout-date-dropdown-month-selected-month">Month</option>
        <option *ngFor="let month of monthOptions" [ngValue]="month.value" data-ui-name="Month label — selected Month" data-ui-component="blackout-date-dropdown" data-testid="blackout-date-dropdown-month-label-selected-month">{{ month.label }}</option>
      </select>
    </div>
    <div class="select is-small">
      <select
        [disabled]="disabled"
        [(ngModel)]="selectedDay"
        (ngModelChange)="onPartChange()"
        [attr.data-testid]="testIdPrefix + '-day'"
        [attr.aria-label]="(ariaLabel ? ariaLabel + ' ' : '') + 'day'"
       data-ui-name="Selected day" data-ui-component="blackout-date-dropdown">
        <option *ngIf="allowEmpty" [ngValue]="''" data-ui-name="Day — selected Day" data-ui-component="blackout-date-dropdown" data-testid="blackout-date-dropdown-day-selected-day">Day</option>
        <option *ngFor="let day of dayOptions" [ngValue]="day" data-ui-name="Day — selected Day" data-ui-component="blackout-date-dropdown" data-testid="blackout-date-dropdown-day-selected-day-day-selected-day">{{ day }}</option>
      </select>
    </div>
    <div class="select is-small">
      <select
        [disabled]="disabled"
        [(ngModel)]="selectedYear"
        (ngModelChange)="onPartChange()"
        [attr.data-testid]="testIdPrefix + '-year'"
        [attr.aria-label]="(ariaLabel ? ariaLabel + ' ' : '') + 'year'"
       data-ui-name="Selected year" data-ui-component="blackout-date-dropdown">
        <option *ngIf="allowEmpty" [ngValue]="''" data-ui-name="Year — selected Year" data-ui-component="blackout-date-dropdown" data-testid="blackout-date-dropdown-year-selected-year">Year</option>
        <option *ngFor="let year of yearOptions" [ngValue]="year" data-ui-name="Year — selected Year" data-ui-component="blackout-date-dropdown" data-testid="blackout-date-dropdown-year-selected-year-year-selected-year">{{ year }}</option>
      </select>
    </div>
  </div>
  <p class="blackout-date-written" *ngIf="formatDateWritten(value)">
    {{ formatDateWritten(value) }}
  </p>
</div>
